<ng-container>
  @if (!filter.additionalFilters) {
    <div class="complex-filter-radio-list">
      <form>
        <ftr-radio-list
          [style]="radioListStyle.MultilineCompact"
          [control]="filterControlAsFormControl"
          [items]="getRadioListOptions(0)"
        ></ftr-radio-list>
      </form>
    </div>
  }
  @if (filter.additionalFilters) {
    <div class="complex-filter-radio-list">
      @for (control of filterControlChildren; track control; let i = $index; let last = $last) {
        <div>
          <form>
            <ftr-radio-list
              [style]="radioListStyle.MultilineCompact"
              [control]="control"
              [items]="getRadioListOptions(i)"
            ></ftr-radio-list>
          </form>
          @if (!last) {
            <hr class="complex-filter-radio-list__divider" />
          }
        </div>
      }
    </div>
  }
</ng-container>
